var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.957031H513V342.957H0V0.957031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 38.957H513V76.957H0V38.957ZM0 114.957H513V152.957H0V114.957ZM0 190.957H513V228.957H0V190.957ZM0 266.957H513V304.957H0V266.957Z",
    fill: "#0038A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.957031H256.5V190.957H0V0.957031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.3 139.657L113.2 162.257L109.4 135.357L85.9998 149.157L94.1998 123.257L66.9998 125.457L85.5998 105.657L60.2998 95.9568L85.6998 86.2568L66.9998 66.4568L94.0998 68.7568L85.8998 42.8568L109.3 56.6568L113.2 29.7568L128.3 52.3568L143.4 29.7568L147.2 56.6568L170.6 42.8568L162.4 68.7568L189.5 66.5568L170.9 86.3568L196.3 96.0568L170.9 105.757L189.5 125.557L162.4 123.357L170.6 149.257L147.2 135.457L143.3 162.357L128.3 139.657ZM128.3 139.157C152.2 140.057 172.3 121.557 173.2 97.6568C174.1 73.7568 155.6 53.6568 131.7 52.7568H128.3C104.4 53.5568 85.6998 73.5568 86.4998 97.3568C87.0998 120.157 105.5 138.457 128.3 139.157ZM128.3 128.557C109.5 128.557 94.2998 113.357 94.2998 94.5568C94.2998 75.7568 109.5 60.5568 128.3 60.5568C147.1 60.5568 162.3 75.7568 162.3 94.5568C162.3 113.357 147 128.557 128.3 128.557Z",
    fill: "#FED443"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.957031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUy);
export default __webpack_public_path__ + "static/media/UY.4b4526315e2ec79e531baacbccb1866e.svg";
export { ForwardRef as ReactComponent };